import gql from 'graphql-tag';
import {
	SHOP_MENU_UPDATE_START,
	SHOP_MENU_UPDATE_SUCCESS,
	SHOP_MENU_UPDATE_ERROR
} from '../../../constants/index';
import { toastr } from 'react-redux-toastr';
import { loadAccount } from '../userAccount/userAccount';

let query = gql`
query($currentPage: Int, $searchList: String) {
	getAllMenu(currentPage: $currentPage, searchList: $searchList){
	  count
	  status
	  errorMessage
	  results{
	   id
	   shopId
	   menuName
	   isEnable
	   menuAvailability{
		menuId
		operationDay
		isOpen
		isWholeDay
	   }
	  }
	}
  }
`;


export default function updateMenuStatus(id, status, currentPage) {
	return async (dispatch, getState, { client }) => {
		dispatch({
			type: SHOP_MENU_UPDATE_START,
			payload: {
				updateLoading: true
			}
		});

		try {
			let errorMessage;

			let mutation = gql`
            mutation updateMenuStatus($id: Int, $status: Boolean) {
                updateMenuStatus(id: $id, status:$status) {
                  status
                  errorMessage
                }
              }
            `;

			const { data } = await client.mutate({
				mutation,
				variables: {
					id,
					status: status == 'false' ? 0 : 1
				},
				refetchQueries: [{ query, variables: { currentPage } }]
			});

			if (data && data.updateMenuStatus && data.updateMenuStatus.status === 200) {
				dispatch({
					type: SHOP_MENU_UPDATE_SUCCESS,
					payload: {
						updateLoading: false
					}
				});
				toastr.success('Success', `The Menu status has been updated successfully.`);
				dispatch(loadAccount())
			} else {
				dispatch({
					type: SHOP_MENU_UPDATE_ERROR,
					payload: {
						updateLoading: false
					}
				});

				errorMessage = (data && data.updateMenuStatus && data.updateMenuStatus.errorMessage) || "Oops! Something went wrong. Please try again.";
				toastr.error('Error!', errorMessage);
			}
		} catch (err) {
			toastr.error('Error!', err);
			dispatch({
				type: SHOP_MENU_UPDATE_ERROR,
				payload: {
					updateLoading: false
				}
			});
		}
	}
};
